import { ClickAwayListener } from '@packages/shared/src/ui/ClickAwayListener/ClickAwayListener';
import type { Dispatch, ReactNode, SetStateAction } from 'react';
import { wrapperStyles } from './Tooltip.styles';
import type { TooltipProps } from './TooltipProps';

export const TooltipWrapper = ({
  variant,
  positioning,
  setPositioningTooltip,
  children,
  contentChildren,
}: {
  variant?: 'inline' | 'default';
  positioning?: TooltipProps['positioning'];
  setPositioningTooltip: Dispatch<SetStateAction<TooltipProps['positioning'] | undefined>>;
  children: ReactNode;
  contentChildren: ReactNode;
}) => (
  <div className={wrapperStyles({ variant, positioning })}>
    {contentChildren}
    <ClickAwayListener
      onClickAway={() => {
        setPositioningTooltip(undefined);
      }}
      strategy="click"
      asChild
    >
      {children}
    </ClickAwayListener>
  </div>
);
